import { isAxiosError } from "axios"

import axiosInstance from "~/api/api.axiosInstance"

import type {
  ConsumptionInsightsDto,
  ProposalConsumptionDto,
  SwitchProposalConsumptionDto,
  UpdateProposalConsumptionDto,
  UpdateProposalConsumptionResponseDto,
} from "../dto/proposal-consumption.dto"

export class ProposalConsumptionService {
  public async getSelection(
    proposalId: string,
  ): Promise<ProposalConsumptionDto> {
    try {
      const response = await axiosInstance.get<ProposalConsumptionDto>(
        `/v2/proposal-consumption/${proposalId}/selection`,
      )

      return response.data
    } catch (error) {
      throw toServiceError(error, `Failed to fetch proposal consumption`)
    }
  }

  public async getInsights(proposalId: string): Promise<ConsumptionInsightsDto> {
    try {
      const response = await axiosInstance.get<ConsumptionInsightsDto>(
        `/v2/proposal-consumption/${proposalId}/insights`,
      )

      return response.data
    } catch (error) {
      throw toServiceError(error, `Failed to fetch consumption insights`)
    }
  }

  public async updateSelection(
    proposalId: string,
    data: UpdateProposalConsumptionDto,
    requestId: string,
  ): Promise<UpdateProposalConsumptionResponseDto> {
    try {
      const response =
        await axiosInstance.put<UpdateProposalConsumptionResponseDto>(
          `/v2/proposal-consumption/${proposalId}/selection`,
          data,
          { headers: { "x-request-id": requestId } },
        )

      return response.data
    } catch (error) {
      throw toServiceError(error, `Failed to update proposal consumption`)
    }
  }

  public async switchSelection(
    proposalId: string,
    data: SwitchProposalConsumptionDto,
    requestId: string,
  ): Promise<UpdateProposalConsumptionResponseDto> {
    try {
      const response =
        await axiosInstance.post<UpdateProposalConsumptionResponseDto>(
          `/v2/proposal-consumption/${proposalId}/selection/switch`,
          data,
          { headers: { "x-request-id": requestId } },
        )

      return response.data
    } catch (error) {
      throw toServiceError(error, `Failed to switch the consumption source`)
    }
  }
}

function toServiceError(error: unknown, fallbackMessage: string): Error {
  if (isAxiosError(error)) {
    return new Error(error.response?.data?.message ?? fallbackMessage)
  }
  if (error instanceof Error) {
    return error
  }

  return new Error(fallbackMessage)
}

export const proposalConsumptionService = new ProposalConsumptionService()
